import { useState, useEffect } from 'react'
import useInterval from '@bt-react/libs/useInterval'
import useWebcast from '../useWebcast'
import { WebcastResponse, defaultState as webcastDefaultState } from '../fetchWebcast'
import getPageState, { PageState } from '../getPageState'
import isIn from '../isIn'

export const PAGE_STATE_VALUES: PageState[] = [ 'scheduled', 'upcoming', 'tminus5', 'live', 'processing', 'ondemand' ]

/**
 * Fetch the state of the page
 * @returns The page state
 */
function useCheckPageState (initialWebcastData: WebcastResponse = webcastDefaultState, hostUrl = ''): PageState {

  const [ intervalDuration, setIntervalDuration ] = useState(1000)
  const { data, mutate } = useWebcast(initialWebcastData, hostUrl)
  const { status, start, entryTime, pageState } = data

  // Since we can't conditionally call the interval below, we can at least amend the interval period
  useEffect(() => {
    
    const fiveMinutes = 300000
    const thirtySeconds = 30000
    const oneSecond = 1000
    const halfAnHour = 30 * 60000

    switch (pageState) {

      case 'scheduled': case 'live':
        return setIntervalDuration(fiveMinutes)
      case 'upcoming':
        return setIntervalDuration(thirtySeconds)
      case 'tminus5':
        return setIntervalDuration(oneSecond)
      case 'processing': case 'ondemand':
        return setIntervalDuration(halfAnHour)
      default:
        break

    }

  }, [ pageState ])

  // Poll to check if the page state should change
  useInterval(() => {
    
    if (!start) return

    if (isIn<PageState>(pageState, 'scheduled', 'upcoming', 'tminus5')) {

      const state = getPageState(start, entryTime, status)

      if (pageState !== state) {

        mutate({ ...data, pageState: state })
      
      }

    }
    
  }, intervalDuration)

  return pageState

}

export default useCheckPageState
